export default {
  title: "Presupuesto",
  description: "Gestiona tu presupuesto de boda",
  totalBudget: "Presupuesto Total",
  totalSpent: "Total Gastado",
  remaining: "Restante",
  toPay: "A pagar",
  exceeded: "Excedido",
  noCategories: "No hay categorías configuradas",
  percentage: "Porcentaje",
  category: "Categoría",
  addExpense: "Agregar Gasto",
  editExpense: "Editar Gasto",
  deleteExpense: "Eliminar Gasto",
  expenseTitle: "Título del Gasto",
  amount: "Cantidad",
  date: "Fecha",
  vendor: "Proveedor",
  notes: "Notas",
  paid: "Pagado",
  pending: "Pendiente",

  noExpenses: {
    title: "No se encontraron gastos",
    description: "Comienza agregando tu primer gasto"
  },
  monthlyExpenses: "Gastos Mensuales",
  sharing: {
    recipientEmail: "Email del Destinatario",
    emailPlaceholder: "ejemplo@email.com",
    recipientName: "Nombre del Destinatario",
    namePlaceholder: "Nombre",
    message: "Mensaje",
    messagePlaceholder: "Tu mensaje...",
    send: "Enviar",
    cancel: "Cancelar",
    title: "Compartir presupuesto"
  },
  addFirstExpense: "Agrega tu primer gasto",
  budgetOverview: "Resumen del Presupuesto",
  expenseDetails: "Detalles del Gasto",
  save: "Guardar",
  cancel: "Cancelar",
  delete: "Eliminar",
  edit: "Editar",
  view: "Ver",
  confirmDelete: "¿Estás seguro de que quieres eliminar este gasto?",
  expenseAdded: "Gasto agregado exitosamente",
  expenseUpdated: "Gasto actualizado exitosamente",
  expenseDeleted: "Gasto eliminado exitosamente",
  budgetExceeded: "Presupuesto excedido",
  budgetWarning: "Advertencia de presupuesto",
  budgetOnTrack: "Presupuesto en curso",
  setBudget: "Establecer Presupuesto",
  editBudget: "Editar Presupuesto",
  budgetAmount: "Cantidad del Presupuesto",
  budgetSet: "Presupuesto establecido exitosamente",
  budgetUpdated: "Presupuesto actualizado exitosamente",
  currency: "Moneda",
  estimatedCost: "Costo Estimado",
  actualCost: "Costo Real",
  difference: "Diferencia",
  overBudget: "Sobre Presupuesto",
  underBudget: "Bajo Presupuesto",
  onBudget: "En Presupuesto",
  budgetAnalysis: "Análisis del Presupuesto",
  categoryBreakdown: "Desglose por Categoría",
  monthlySpending: "Gastos Mensuales",
  upcomingExpenses: "Gastos Próximos",
  recentExpenses: "Gastos Recientes",
  budgetSummary: "Resumen del Presupuesto",
  totalAllocated: "Total Asignado",
  totalUnallocated: "Total No Asignado",
  allocationPercentage: "Porcentaje de Asignación",
  spendingTrend: "Tendencia de Gastos",
  averageExpense: "Gasto Promedio",
  largestExpense: "Gasto Más Grande",
  smallestExpense: "Gasto Más Pequeño",
  expenseCount: "Número de Gastos",
  budgetUtilization: "Utilización del Presupuesto",
  projectedTotal: "Total Proyectado",
  savingsGoal: "Meta de Ahorro",
  emergencyFund: "Fondo de Emergencia",
  contingencyPercentage: "Porcentaje de Contingencia",
  recommendedContingency: "Contingencia Recomendada",
  import: "Importar",
  exportToCsv: "Exportar a CSV",
  exportToPdf: "Exportar a PDF",
  importFromCsv: "Importar desde CSV",
  downloadTemplate: "Descargar Plantilla",
  budgetTemplate: "Plantilla de Presupuesto",
  customCategory: "Categoría Personalizada",
  addCategory: "Agregar Categoría",
  categoryName: "Nombre de la Categoría",
  categoryBudget: "Presupuesto de la Categoría",
  categoryAdded: "Categoría agregada exitosamente",
  categoryUpdated: "Categoría actualizada exitosamente",
  categoryDeleted: "Categoría eliminada exitosamente",
  duplicateCategory: "La categoría ya existe",
  search: "Buscar gastos",
  filter: "Filtrar",
  filterByCategory: "Filtrar por Categoría",
  filterByStatus: "Filtrar por Estado",
  filterByDate: "Filtrar por Fecha",
  sortBy: "Ordenar por",
  sortByDate: "Ordenar por Fecha",
  sortByAmount: "Ordenar por Cantidad",
  sortByCategory: "Ordenar por Categoría",
  ascending: "Ascendente",
  descending: "Descendente",
  clearFilters: "Limpiar Filtros",
  noFilterResults: "No hay gastos que coincidan con tus filtros",
  showAll: "Mostrar Todo",
  showPaid: "Mostrar Pagados",
  showPending: "Mostrar Pendientes",
  thisMonth: "Este Mes",
  lastMonth: "Mes Pasado",
  thisYear: "Este Año",
  customRange: "Rango Personalizado",
  from: "Desde",
  to: "Hasta",
  apply: "Aplicar",
  reset: "Restablecer",
  expenseCreated: "Gasto creado exitosamente",
  totalExpenses: "{{count}} gastos",
  estimateBudget: "Estimar presupuesto",
  estimateBudgetShort: "Estimar",
  newExpense: "Nuevo gasto",
  add: "Agregar",
  overview: "Vista general",
  distribution: "Distribución",
  expensesList: "Lista de gastos",
  exportPdf: "Exportar PDF",
  budgetUsed: "Presupuesto utilizado",
  loading: "Cargando...",
  total: "Total",
  confirmDeleteExpense: "¿Estás seguro de que quieres eliminar este gasto?",
  noExpensesText: "Ningún gasto",
  importExpenses: "Importar gastos",
  exportExpenses: "Exportar gastos",
  budgetDetails: "Detalles del presupuesto",
  budgetHistory: "Historial del presupuesto",
  budgetAnalytics: "Análisis del presupuesto",
  budgetSettings: "Configuración del presupuesto",
  spent: "Gastado",

  categories: {
    venue: "Lugar",
    catering: "Catering",
    flowers: "Flores",
    photography: "Fotografía",
    music: "Música",
    attire: "Vestuario",
    rings: "Anillos",
    transportation: "Transporte",
    decoration: "Decoración",
    invitations: "Invitaciones",
    gifts: "Regalos",
    honeymoon: "Luna de miel",
    miscellaneous: "Varios",
    beauty: "Belleza",
    other: "Otros",
    videography: "Videografía",
    accommodation: "Alojamiento",
    stationery: "Papelería",
    general: "General",
    "Lieu et Réception": "Lugar y Recepción",
    "Animation et Photo": "Animación y Foto",
    "Tenues et Accessoires": "Vestimenta y Accesorios",
    title: "Categorías"
  },

  form: {
    title: "Título",
    amount: "Cantidad",
    category: "Categoría",
    date: "Fecha",
    vendor: "Proveedor",
    notes: "Notas",
    paid: "Pagado",
    errors: {
      titleRequired: "El título es obligatorio",
      amountRequired: "La cantidad es obligatoria",
      categoryRequired: "La categoría es obligatoria",
      amountPositive: "La cantidad debe ser positiva"
    },
    description: "Descripción",
    dueDate: "Fecha de vencimiento",
    status: "Estado",
    submit: "Guardar",
    cancel: "Cancelar",
    name: "Nombre"
  },

  filters: {
    all: "Todos",
    category: "Categoría",
    status: "Estado",
    vendor: "Proveedor",
    categoryPlaceholder: "Seleccionar categoría",
    vendorPlaceholder: "Seleccionar proveedor",
    budgetsearch: "Buscar gastos",
    group: "Categoría",
    groupPlaceholder: "Seleccionar una categoría...",
    tableAssigned: "Mesa asignada",
    allCategories: "Todas las categorías",
    allStatuses: "Todos los estados",
    startDate: "Fecha de inicio",
    endDate: "Fecha de fin",
    minAmount: "Monto mín (€)",
    maxAmount: "Monto máx (€)",
    resetFilters: "Restablecer filtros",
    search: "Buscar un gasto",
    clear: "Limpiar filtros",
    apply: "Aplicar",
    previous: "Anterior",
    next: "Siguiente",
  },

  status: {
    paid: "Pagado",
    unpaid: "No pagado",
    pending: "Pendiente",
    cancelled: "Cancelado"
  },

  table: {
    title: "Título",
    amount: "Cantidad",
    category: "Categoría",
    date: "Fecha",
    status: "Estado",
    description: "Descripción",
    actions: "Acciones"
  },

  estimator: {
    title: "Estimador de presupuesto",
    guestCount: "Número de invitados",
    region: "Región",
    services: "Servicios",
    lieu: "Lugar",
    traiteur: "Catering",
    photographie: "Fotografía",
    fleurs: "Flores",
    musique: "Música",
    tenues: "Vestimenta",
    calculate: "Calcular",
    estimatedBudget: "Presupuesto estimado",
    validateBudget: "Validar presupuesto",
    adjustAmount: "Ajustar cantidad",
    modifyCriteria: "Modificar criterios",
    next: "Siguiente",
    previous: "Anterior",
    ileDeFrance: "Isla de Francia (París)",
    paca: "PACA (Sur de Francia)",
    london: "Londres",
    otherUK: "Otro Reino Unido",
    madrid: "Madrid",
    barcelona: "Barcelona",
    berlin: "Berlín",
    munich: "Múnich",
    otherRegion: "Otra región",
    style: "¿Qué estilo de boda deseas?",
  },

  noExpensesFiltered: {
    title: "Ningún gasto coincide con tus filtros",
    description: "Intenta ajustar tus criterios de búsqueda"
  },

  overrun: {
    title: "Presupuesto excedido",
    description: "Has excedido tu presupuesto previsto"
  },

  success: {
    budgetUpdated: "Presupuesto actualizado exitosamente"
  },

  errors: {
    addExpense: "Error al agregar el gasto",
    deleteExpense: "Error al eliminar el gasto",
    updateExpense: "Error al actualizar el gasto",
    loadExpenses: "Error al cargar los gastos",
    loadCategories: "Error al cargar las categorías",
    loadWedding: "Error al cargar los datos de la boda",
    loadTemplate: "Error al cargar la plantilla",
    updateBudget: "Error al actualizar el presupuesto",
    noTemplateAvailable: "No hay plantilla disponible",
    noWeddingFound: "No se encontró boda",
    loadData: "Error al cargar los datos",
    noUser: "Ningún usuario conectado",
    missingWeddingId: "Falta ID de boda"
  },

  pageExample: {
    title: "Gestión del Presupuesto",
    subtitle: "Planifica y rastrea tus gastos de boda",
    connectedAs: "Conectado como",
    noAccess: "Sin acceso",
    overviewDescription: "Resumen general de tus gastos y presupuesto restante",
    detailedExpenses: "Gastos Detallados",
    detailedExpensesDescription: "Lista completa de todos tus gastos",
    share: "Compartir",
    venues: {
      receptionVenue: "Lugar de Recepción",
      chateauVersailles: "Castillo de Versalles",
    },
    access: {
      readOnlyAccess: "Acceso solo de lectura - No se puede modificar",
      advancedConfig: "Configuración Avanzada",
      advancedConfigDescription: "Configuración y ajustes del presupuesto",
      adminOnly: "Solo administrador",
      adminZone: "Zona de Administración",
      adminZoneDescription: "Esta sección contiene configuraciones sensibles que solo son accesibles para administradores.",
      exportData: "Exportar Datos",
      resetBudget: "Restablecer Presupuesto",
      permissionsInfo: "Información de tus Permisos",
      read: "Leer",
      write: "Escribir",
      delete: "Eliminar",
      share: "Compartir",
    },
    description: "Este es un ejemplo de página de presupuesto con datos ficticios",
    accessLevel: "Nivel de acceso",
    permissions: "Permisos",
    venue: {
      title: "Lugar",
      name: "Castillo de las Rosas",
      capacity: "Capacidad: 150 personas",
      location: "Provenza, Francia",
      contact: "Contacto: +33 1 23 45 67 89"
    },
    admin: {
      title: "Administración",
      exportData: "Exportar datos",
      importData: "Importar datos",
      backupData: "Respaldar datos",
      resetData: "Restablecer datos"
    },
    status: {
      connected: "Conectado",
      synchronized: "Sincronizado",
      lastUpdate: "Última actualización: {{date}}"
    }
  },

  initialBudget: "Presupuesto inicial",
  used: "utilizado",
  paymentStatus: "Estado de Pagos",
  categoryProgress: "Progreso por Categoría",
  addExpenseLabel: "Agregar un gasto",

  expenses: {
    title: "Gastos",
    add: "Agregar gasto",
    edit: "Editar gasto",
    name: "Nombre",
    amount: "Cantidad",
    category: "Categoría",
    date: "Fecha",
    paid: "Pagado",
    unpaid: "No pagado",
    notes: "Notas",
    vendor: "Proveedor",
    noExpenses: "Ningún gasto",
    total: "Total",
    filter: "Filtrar",
    search: "Buscar",
    delete: "Eliminar",
    confirm: "Confirmar"
  },

  modal: {
    title: "Gasto",
    edit: "Editar gasto",
    delete: "Eliminar gasto",
    confirmDelete: "¿Estás seguro de que quieres eliminar este gasto?"
  },

  summary: {
    total: "Total",
    spent: "Gastado",
    remaining: "Restante",
    overBudget: "Exceso",
    currency: "€"
  },

  analytics: {
    title: "Análisis presupuestario",
    insights: {
      title: "Insights y tendencias",
      topCategory: {
        title: "Categoría principal",
        description: "{{category}} representa el {{percentage}}% de tus gastos con {{amount}}"
      },
      overBudget: {
        title: "Presupuesto excedido",
        description: "Has excedido tu presupuesto en un {{percentage}}% ({{amount}})"
      },
      nearBudget: {
        title: "Presupuesto casi alcanzado",
        description: "Has utilizado el {{percentage}}% de tu presupuesto. Te queda {{remaining}}"
      },
      increasingTrend: {
        title: "Gastos en aumento",
        description: "Tus gastos han aumentado en {{amount}} este mes ({{month}})"
      },
      decreasingTrend: {
        title: "Gastos en disminución",
        description: "Tus gastos han disminuido en {{amount}} este mes ({{month}})"
      }
    },
    charts: {
      categoryDistribution: "Distribución por categoría",
      monthlyTrend: "Tendencia mensual",
      monthlySpending: "Gastos mensuales",
      cumulativeSpending: "Gastos acumulados",
      averagePerCategory: "Promedio por categoría",
      averageSpending: "Promedio de gastos"
    },
    details: {
      title: "Estadísticas detalladas",
      transactions: "transacciones",
      average: "Promedio"
    },
    overview: "Vista general",
    byCategory: "Por categoría",
    byMonth: "Por mes",
    trends: "Tendencias"
  },

  messages: {
    createSuccess: "Gasto agregado exitosamente",
    updateSuccess: "Gasto actualizado exitosamente",
    deleteSuccess: "Gasto eliminado exitosamente",
    deleteConfirm: "¿Estás seguro de que quieres eliminar este gasto?",
    error: "Ha ocurrido un error",
    budgetCreated: "Presupuesto creado exitosamente",
    budgetUpdated: "Presupuesto actualizado exitosamente",
    budgetDeleted: "Presupuesto eliminado exitosamente",
    expenseAdded: "Gasto agregado exitosamente",
    expenseUpdated: "Gasto actualizado exitosamente",
    expenseDeleted: "Gasto eliminado exitosamente",
    categoryAdded: "Categoría agregada exitosamente",
    categoryUpdated: "Categoría actualizada exitosamente",
    categoryDeleted: "Categoría eliminada exitosamente"
  },
};